const ArchParts3500 = (index, nodes, materials, metal, first, last, archAntiHotSpotTape, antiHotSpotTape, zigzag, cropSupportBar) => {
  let partsToShow = []

  if(archAntiHotSpotTape) {
    partsToShow.push(
      <mesh key="ANTI-HOT-TAPE008" geometry={nodes['ANTI-HOT-TAPE008'].geometry} material={materials.tape} />
    )
  }
      
  if(first || last) {
    partsToShow.push(
      <group key={`3500-arch-parts-${index}`}>
        <group position={last ? [-3.48, 0.33, -1.968] : [0.007, 0.33, 1.969]} rotation={last ? [2.474, -0.126, -1.316] : [0.669, 0.121, 1.83]}>
          <mesh name="PART_R32-2210-BRACE_BAR_LEFT" geometry={nodes['PART_R32-2210-BRACE_BAR_LEFT001'].geometry} material={materials['Material_0.010']} >
            {metal}
          </mesh>
          <mesh name="32mm_Brace_Bracket020" geometry={nodes['32mm_Brace_Bracket020'].geometry} material={materials['Material_0.011']} position={[0.012, 0.008, 0.031]} rotation={[1.445, -0.257, -2.272]}>
            {metal}
            {/* <mesh name="Mesh_1021" geometry={nodes.Mesh_1021.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh>
            <mesh name="Mesh_2021" geometry={nodes.Mesh_2021.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh>
            <mesh name="Mesh_3021" geometry={nodes.Mesh_3021.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh>
            <mesh name="Mesh_4023" geometry={nodes.Mesh_4023.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh> */}
          </mesh>
          <mesh name="32mm_Brace_Bracket021" geometry={nodes['32mm_Brace_Bracket021'].geometry} material={materials['Material_0.011']} position={[-0.017, 0.001, -2.514]} rotation={[1.908, 0.302, 0.858]}>
            {metal}
            {/* <mesh name="Mesh_1022" geometry={nodes.Mesh_1022.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh> */}
            {/* <mesh name="Mesh_2022_1" geometry={nodes.Mesh_2022_1.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh> */}
            {/* <mesh name="Mesh_3022_1" geometry={nodes.Mesh_3022_1.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[-Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh> */}
            {/* <mesh name="Mesh_4024" geometry={nodes.Mesh_4024.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[-Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh> */}
          </mesh>
          {
            antiHotSpotTape &&
              <mesh name="ANTI-HOT-TAPE007" geometry={nodes['ANTI-HOT-TAPE007'].geometry} material={materials.tape} scale={1.001}/>
          }
        </group>
        <group position={last ? [0.007, 0.33, -1.969] : [-3.48, 0.33, 1.969]} rotation={last ? [2.48, 0.121, 0.858] : [0.662, -0.121, -2.283]}>
          <mesh name="PART_R32-2210-BRACE_BAR_RIGHT002" geometry={nodes['PART_R32-2210-BRACE_BAR_RIGHT002'].geometry} material={materials['Material_0.010']} >
            {metal}
          </mesh>
          <mesh name="32mm_Brace_Bracket018" geometry={nodes['32mm_Brace_Bracket018'].geometry} material={materials['Material_0.011']} position={[-0.028, -0.012, 0.016]} rotation={[1.417, 0.71, -0.807]}>
            {metal}
            {/* <mesh name="Mesh_1004_1" geometry={nodes.Mesh_1004_1.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh> */}
            {/* <mesh name="Mesh_2004_1" geometry={nodes.Mesh_2004_1.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh> */}
            {/* <mesh name="Mesh_3004_1" geometry={nodes.Mesh_3004_1.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh>
            <mesh name="Mesh_4003_1" geometry={nodes.Mesh_4003_1.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh> */}
          </mesh>
          <mesh name="32mm_Brace_Bracket019" geometry={nodes['32mm_Brace_Bracket019'].geometry} material={materials['Material_0.011']} position={[0.027, 0.008, -2.493]} rotation={[1.847, 0.205, 2.136]}>
            {metal}
            {/* <mesh name="Mesh_1005_1" geometry={nodes.Mesh_1005_1.geometry} material={materials['Material_1.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh>
            <mesh name="Mesh_2005_1" geometry={nodes.Mesh_2005_1.geometry} material={materials['Material_2.003']} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
              {metal}
            </mesh>
            <mesh name="Mesh_3005_1" geometry={nodes.Mesh_3005_1.geometry} material={materials['Material_3.002']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh>
            <mesh name="Mesh_4004_1" geometry={nodes.Mesh_4004_1.geometry} material={materials['Material_2.003']} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
              {metal}
            </mesh> */}
          </mesh>
          {
            antiHotSpotTape &&
              <mesh name="ANTI-HOT-TAPE006" geometry={nodes['ANTI-HOT-TAPE006'].geometry} material={materials.tape} scale={1.001}/>
          }
        </group>
        {
          zigzag &&
            <mesh name="3500_ZIGZAG" geometry={nodes['3500_ZIGZAG'].geometry} material={materials.zigzag} position={[-2.505, 0, 0]} rotation={[-Math.PI, 0, 0]} />
        }
      </group>
    )
  }
  if(!first && !last && cropSupportBar) {
    partsToShow.push(
      <mesh name="CROP-SUPPORT-BAR" key={`3500-crop-support-bar-${index}`} geometry={nodes.PART_35R32_CROP_SUPPORT_BAR001.geometry} material={materials['Material_0.016']} position={[-1.285, 2.031, -0.003]} rotation={[-Math.PI / 2, Math.PI / 2, 0]}>
        {metal}
        <group name="Brace_Bracket_R32_with_nut_and_bolt006" position={[-0.059, 0.04, 0.726]} rotation={[Math.PI / 2, 0, -0.55]}>
          <group name="8mm_x_45mm_hex_bolt006" position={[0.054, 0.025, 0.048]} rotation={[0, 0.052, -1.351]}>
            <mesh name="Mesh_1023" geometry={nodes.Mesh_1023.geometry} material={materials['Material_1.007']} >
              {metal}
            </mesh>
            <mesh name="Mesh_2023" geometry={nodes.Mesh_2023.geometry} material={materials['Material_2.006']} >
              {metal}
            </mesh>
          </group>
          <group name="M8_nut001" position={[0.051, 0.018, 0.038]} rotation={[Math.PI, -0.052, 2.979]}>
            <mesh name="Mesh_3023" geometry={nodes.Mesh_3023.geometry} material={materials['Material_3.005']} >
              {metal}
            </mesh>
            <mesh name="Mesh_4026" geometry={nodes.Mesh_4026.geometry} material={materials['Material_2.006']} >
              {metal}
            </mesh>
          </group>
          <mesh name="32mm_Brace_Bracket022" geometry={nodes['32mm_Brace_Bracket022'].geometry} material={materials['Material_0.017']} position={[0.022, 0.012, 0.045]} >
            {metal}
          </mesh>
        </group>
        <group name="Brace_Bracket_R32_with_nut_and_bolt007" position={[-0.054, -0.048, -1.636]} rotation={[-Math.PI / 2, 0, -0.55]}>
          <mesh name="32mm_Brace_Bracket023" geometry={nodes['32mm_Brace_Bracket023'].geometry} material={materials['Material_0.017']} position={[0.022, 0.012, 0.045]} >
            {metal}
          </mesh>
          <mesh name="Mesh_1024" geometry={nodes.Mesh_1024.geometry} material={materials['Material_1.007']} position={[0.054, 0.025, 0.048]} rotation={[0, 0.052, -1.351]} >
            {metal}
          </mesh>
          <mesh name="Mesh_2024" geometry={nodes.Mesh_2024.geometry} material={materials['Material_2.006']} position={[0.054, 0.025, 0.048]} rotation={[0, 0.052, -1.351]} >
            {metal}
          </mesh>
          <mesh name="Mesh_3024" geometry={nodes.Mesh_3024.geometry} material={materials['Material_3.005']} position={[0.051, 0.018, 0.038]} rotation={[Math.PI, -0.052, 2.979]} >
            {metal}
          </mesh>
          <mesh name="Mesh_4027" geometry={nodes.Mesh_4027.geometry} material={materials['Material_2.006']} position={[0.051, 0.018, 0.038]} rotation={[Math.PI, -0.052, 2.979]} >
            {metal}
          </mesh>
        </group>
      </mesh>
    )
  }

  return partsToShow
}

export default ArchParts3500